<template>
  <div v-if="product">
    <div class="product-content">
      <div class="product-info">
        <div class="product-price">${{ new Intl.NumberFormat().format(product['total-price']) }}</div>
        <div class="product-title" v-if="!hideTitle">{{ product['product-name'] }}</div>
      </div>
      <div class="product-image" v-if="type === 'one'"><img v-if="!hideTitle && product['product-image-url']" :src="product['product-image-url']"></div>
    </div>
    <template v-if="!hideDescription">
      <div class="product-desc" v-if="type === 'mandatory' && product['product-description']"><div v-html="product['product-description']"></div></div>
      <div class="product-desc" v-if="type !== 'mandatory' && product['product-description']" v-html="product['product-description']"></div>
    </template>
  </div>
</template>

<script>
import axios from 'axios';

const BASE_URL_DEV = process.env.NODE_ENV !== 'production' ? 'https://dev13.3degreesnorth.com.au' : '';

export default {
  props: {
    type: { type: String },
    hideTitle: { type: Boolean, default: false },
    hideDescription: { type: Boolean, default: false },
    item: { type: Object }
  },
  data() {
    return {
      product: null
    }
  },
  mounted() {
    this.getProductInfo();
  },
  methods: {
    async getProductInfo() {
      axios.defaults.baseURL = BASE_URL_DEV + '/api/';

      const productKey = `product-${this.item['product-code'].toLowerCase()}`;
      const response = await axios({ method: 'get', url: `config/${productKey}` });
      if (response.data) {
        this.product = { ...this.item, ...response.data[productKey] };
        if (this.product['product-image-url']) {
          this.product['product-image-url'] = BASE_URL_DEV + this.product['product-image-url'];
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/fonts/stylesheet.css';

.product-content {
  display: flex;

  .product-info {
    flex-grow: 1;

    .product-price {
      font-size: 22px;
      font-weight: 600;
      line-height: 22px;
      color: #161E2E;
    }

    .product-title {
      font-size: 18px;
      font-weight: 600;
      line-height: 36px;
      font-family: "Gotham Narrow Light";
      color: #414042;
    }
  }

  .product-image {
    height: 80px;
    flex-shrink: 1;

    @media screen and (max-width: 767px) {
      height: 56px;
    }

    img {
      height: 100%;
      border-radius: 6px;
    }
  }
}

.product-desc {
  font-size: 14px;
  font-family: "Gotham Narrow Light";
  line-height: 17px;
  color: #414042;
  padding-top: 10px;
  white-space: pre-wrap;
}
</style>
